<template>
  <b-modal
    id="delete-team-modal"
    title="Delete Team"
    hide-footer
    @hidden="hiddenHandler"
  >
    <h4 class="mb-2">
      Are you sure you want to delete team {{ name }}?
    </h4>
    <validation-observer
      ref="formRef"
    >
      <b-form
        autocomplete="off"
        class="p-2"
        @submit.prevent="submitInactivation"
      >
        <validation-provider
          #default="{ errors }"
          name="Reason"
          rules="required"
        >
          <b-form-group
            label="Reason"
            label-for="delete-rason"
          >
            <b-form-select
              id="delete-rason"
              v-model="deleteRason.deleteReasonId"
              text-field="reason.en"
              value-field="id"
              :options="deleteReasons"
            />
            <span class="text-danger"> {{ errors[0] }} </span>
          </b-form-group>
        </validation-provider>
        <validation-provider
          v-if="deleteRason.deleteReasonId == 0"
          #default="{ errors }"
          name="Other Reason"
          rules="required"
        >
          <b-form-group
            label="Other Reason"
            label-for="other-reason"
          >
            <b-form-textarea
              id="other-reason"
              v-model="deleteRason.deleteRasonText"
            />
            <span class="text-danger"> {{ errors[0] }} </span>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
    <div class="d-flex justify-content-around">
      <b-button
        class="mr-1"
        variant="danger"
        :disabled="deletingTeam"
        @click="deleteTeam"
      >
        <b-spinner
          v-if="deletingTeam"
          small
        />
        <span v-else>Yes, Delete Team</span>
      </b-button>
      <b-button
        variant="outline-primary"
        @click="$bvModal.hide('delete-team-modal')"
      >
        <span>No, keep the team</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BFormSelect, BForm, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BForm,
  },
  props: {
    team: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const name = computed(() => props.team?.name?.en || '')
    const formRef = ref(null)
    const loading = ref(false)
    const deleteRason = ref({
      deleteReasonId: null,
      deleteRasonText: '',
    })
    const deleteReasons = ref([])
    const fetchDeleteRasons = async () => {
      loading.value = true

      const result = await axiosIns.get('/teams/delete-reasons')
      deleteReasons.value = result.data.data
      deleteReasons.value.unshift({
        id: 0,
        reason: {
          en: 'OTHER',
          ar: 'OTHER',
        },
      })
      console.log(deleteReasons.value)
      loading.value = false
    }
    fetchDeleteRasons()
    const deletingTeam = ref(false)
    const deleteTeam = async () => {
      const res = await formRef.value.validate()
      if (!res) return
      try {
        deletingTeam.value = true
        const PAYLOAD = {}
        if (deleteRason.value.deleteReasonId === 0) {
          PAYLOAD.deleteRasonText = deleteRason.value.deleteRasonText
          PAYLOAD.deleteReasonId = 'OTHER'
        } else {
          PAYLOAD.deleteRasonText = ''
          PAYLOAD.deleteReasonId = deleteRason.value.deleteReasonId
        }

        await axiosIns.delete(`/teams/${props.team.id}`, {
          data: PAYLOAD,
        })
        ctx.root.$bvModal.hide('delete-team-modal')
        ctx.emit('team-deleted')
      } finally {
        deletingTeam.value = false
      }
    }

    const hiddenHandler = () => {
      deleteRason.value.deleteRasonText = ''
      deleteRason.value.deleteReasonId = null
    }
    return {
      name,
      deleteTeam,
      deletingTeam,
      deleteReasons,
      formRef,
      loading,
      hiddenHandler,
      deleteRason,
      required,
    }
  },
}
</script>

      <style>

      </style>
